import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Badge, Center, Container, Loader, Paper, Stack, Text, Title } from "@mantine/core";
import { getAuthHeaders } from "../../../api/authHelper";

type ParkingArea = { parkingAreaId: number; name: string };
type ParkingValidationDto = {
    isValid: boolean; eventId: number; personId: number;
    personName?: string; eventName?: string; note?: string; parkingAreas?: ParkingArea[];
};
export default function ParkingValidationPage() {
    const apiUrl = process.env.REACT_APP_API_URL;
    const { eventId, personId } = useParams();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<ParkingValidationDto | null>(null);
    useEffect(() => {
        const controller = new AbortController();
        async function load() {
            setLoading(true);
            try {
                if (!apiUrl || !eventId || !personId) throw new Error("Missing URL parameters.");
                const res = await fetch(`${apiUrl}/api/parking/validate/${eventId}/${personId}`, { headers: getAuthHeaders(), signal: controller.signal });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                setData(await res.json());
            } catch (e) {
                if (!controller.signal.aborted) setData({ isValid: false, eventId: Number(eventId), personId: Number(personId) });
            } finally { if (!controller.signal.aborted) setLoading(false); }
        }
        load();
        return () => controller.abort();
    }, [apiUrl, eventId, personId]);
    const names = data?.parkingAreas?.length ? data.parkingAreas.map(a => a.name) : ["VIP Parking"];
    return <Container size="sm" py="xl"><Paper withBorder p="xl" radius="lg" style={{ backgroundColor: loading ? "#f8f9fa" : data?.isValid ? "#d3f9d8" : "#ffe3e3" }}>
        {loading ? <Center><Stack align="center"><Loader color="red" /><Text>Checking parking access...</Text></Stack></Center> : data?.isValid ?
            <Stack align="center" gap="md"><Badge color="green" size="xl">VALID</Badge><Title order={2} ta="center">ACCESS APPROVED</Title>
                <Text size="lg" fw={600}>{data.personName}</Text><Text>{data.eventName}</Text>
                <Text fw={600}>WELCOME TO</Text>{names.map(name => <Title order={2} key={name} ta="center">{name.toUpperCase()}</Title>)}
                {data.note && <Text ta="center">{data.note}</Text>}
            </Stack> : <Stack align="center"><Badge color="red" size="xl">DENIED</Badge><Title order={2}>ACCESS DENIED</Title><Text>This person does not have parking access.</Text></Stack>}
    </Paper></Container>;
}
